import React from 'react'
import PropTypes from 'prop-types'
import { sizes } from '@qflow/theme'

export function EditPencil({
  size = sizes.MEDIUM,
  colour = 'currentColor',
  ...props
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="17"
      viewBox="0 0 16 17"
      {...props}
      style={{ width: size, height: size }}
    >
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M13.75 13.5625H2.25C1.97344 13.5625 1.75 13.7859 1.75 14.0625V14.625C1.75 14.6938 1.80625 14.75 1.875 14.75H14.125C14.1938 14.75 14.25 14.6938 14.25 14.625V14.0625C14.25 13.7859 14.0266 13.5625 13.75 13.5625ZM4.02656 12.25C4.05781 12.25 4.08906 12.2469 4.12031 12.2422L6.74844 11.7812C6.77969 11.775 6.80938 11.7609 6.83125 11.7375L13.4547 5.11406C13.4692 5.09961 13.4807 5.08244 13.4885 5.06354C13.4963 5.04463 13.5004 5.02437 13.5004 5.00391C13.5004 4.98344 13.4963 4.96318 13.4885 4.94428C13.4807 4.92538 13.4692 4.90821 13.4547 4.89375L10.8578 2.29531C10.8281 2.26563 10.7891 2.25 10.7469 2.25C10.7047 2.25 10.6656 2.26563 10.6359 2.29531L4.0125 8.91875C3.98906 8.94219 3.975 8.97031 3.96875 9.00156L3.50781 11.6297C3.49261 11.7134 3.49804 11.7995 3.52364 11.8807C3.54923 11.9618 3.59421 12.0355 3.65469 12.0953C3.75781 12.1953 3.8875 12.25 4.02656 12.25Z"
        fill={colour}
      />
    </svg>
  )
}

EditPencil.propTypes = {
  colour: PropTypes.string,
  size: PropTypes.string
}
